<template>
  <b-container fluid style="padding-top: 10px">
    <vue-good-table
        v-if="true"
        :columns="columns"
        :rows="rows"
        styleClass="vgt-table condensed table-bordered table-striped"
        @on-row-click="onRowClick"
        :sort-options="{
                    enabled: true,
                    initialSortBy: {
                        field: 'name',
                        type: 'desc'
                    }
                }"
        :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
      <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'Delete'">
                    <b-button size="sm"
                              @click="deleteParent(props.column.field,props.formattedRow[props.column.field])">
                            Admin Account Info
                </b-button>
                </span>
        <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                </span>
      </template>
    </vue-good-table>
  </b-container>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import Swal from "sweetalert2";

export default {
  name: "LoginAdmin",
  components: {
    Datepicker,
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: "Name",
          field: "name"
        },
        {
          label: "Street Address",
          field: "streetAddress"
        },
        {
          label: "City",
          field: "city"
        },
        {
          label: "State",
          field: "state"
        },
        {
          label: "Delete",
          field: "id"
        }],
      items: [],
      rows: []
    }
  },
  mounted() {
    let self = this;
    this.$http.get("/groups/parent-company")
        .then(result => {
          self.rows = result.data;
          console.log("Parent Companies: " + self.rows);
        })
        .catch(error => {
          console.log("The error: " + error);
        })

  },
  methods: {
    isNotCertifier: function () {
      return !localStorage.getItem("roles").includes("THIRD_PARTY_CERTIFIER");
    },
    selected(item) {
      localStorage.setItem('adminImpersonationGroupId', item.groupId);
      this.$router.push({name: 'SurveyLink', params: {surveyKey: item.surveyId, groupId: item.groupId}});
    },
    onRowClick(params) {
      let row = params.row;
      console.log(`Row Id: ${row.id}`);
      this.$router.push({
        name: 'Update Parent Company',
        params: {id: row.id}
      });
    },
    deleteParent: function (group) {
      let url = 'groups/parent-company/${id}';
      this.$http.delete(url, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(function (response) {
            if (response.status === 202 || response.status === 200) {
              self.displayResult(`Parent Company Deleted successfully.`);
            }
          })
          .catch(function (error) {
            let issuesObject = error.response.data[0];
            // This may be an issue since companies may have the same name.
            if (issuesObject && issuesObject.field) {
              Swal.fire("Parent Company Deletion Failed",
                  `Creation failed, company with ${issuesObject.field} = ${issuesObject.value} already has a parent.`
                  , "error");
            } else {
              Swal.fire("Parent Company creation Failed",
                  `Creation failed, with error: ${error.response.message}`
                  , "error");
            }
          });
    },
    dismissTheModal: function () {
      this.$bvModal.hide("modal-1");
      this.surveyToCertify = '';
      this.groupIdToCertify = '';
      this.certificationDate = '';
    },
    saveAction: function () {
      this.$bvModal.hide("modal-1");
      let certRequest = {
        certificationDate: new Date(this.certificationDate),
        surveyResponseId: this.surveyToCertify,
        certifierId: localStorage.getItem('user'),
        groupId: this.groupIdToCertify
      }

      let inviteRequestJson = JSON.stringify(certRequest, null, 3);
      this.$http.post("survey/certify", inviteRequestJson
          , {
            headers: {
              'content-type': 'application/json'
            }
          })
          .then(response => {
            console.log(response);
            swal({
              title: "Group has been Certified",
              type: "success",
              timer: 3000
            });
          })
          .catch(fail => {
            swal(" Certification Attempt Failed. [" + fail + "]");
          });
    }
  }
}
</script>
